module.exports = __webpack_public_path__ + "static/media/print_01_A.2604b182.png";